import {Component, Input, OnInit} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {AuthService} from "../../../shared/services/auth.service";
import {Router} from "@angular/router";
import {MatDrawer} from "@angular/material/sidenav";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input()
  drawer: MatDrawer;

  title = environment.mainName;
  subtitle = environment.subtitleHeader;

  get user() {
    return this.authService.user;
  }

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  logout() {
    this.authService.logout()
      .subscribe(() => this.router.navigateByUrl('/auth/login'));
  }

  toEditProfile() {
    this.router.navigate(['auth', 'edit-profile']);
  }
}
